document.addEventListener("DOMContentLoaded", () => {
  const tabButtons = document.querySelectorAll(".customers-notice-tab-btn");
  
  tabButtons.forEach(button => {
    button.addEventListener("click", () => {
      // Get the target panel
      const targetId = button.getAttribute("data-target");
      const targetPanel = document.getElementById(targetId);
      
      if (!targetPanel) return;

      // Find the parent container to scope the changes
      const container = button.closest(".customers-notice-tabs-container");
      
      // Deactivate all buttons in this container
      const allButtons = container.querySelectorAll(".customers-notice-tab-btn");
      allButtons.forEach(btn => {
        btn.classList.remove("active");
        btn.setAttribute("aria-selected", "false");
      });
      
      // Deactivate all panels in this container
      const allPanels = container.querySelectorAll(".customers-notice-tab-panel");
      allPanels.forEach(panel => {
        panel.classList.remove("active");
      });
      
      // Activate the clicked button and its panel
      button.classList.add("active");
      button.setAttribute("aria-selected", "true");
      targetPanel.classList.add("active");
    });
  });
});
